import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../environments/environment';
import { AuthService } from './_services/auth.service';

@Component({
    selector: 'app-root',
    template: '<router-outlet><router-outlet>'
})
export class AppComponent implements OnInit {
    user: string | null = null

    constructor(private _auth: AuthService, private _router: Router) {
    }

    ngOnInit() {
        if (window.location.protocol != environment.protocol) {
            window.location.href = window.location.href.replace(window.location.protocol, environment.protocol); 
            return;
        }

        this._auth.initAuth().then(res => {
            if (res.idTokenData) {
                this.user = `${res.idTokenData['given_name']} ${res.idTokenData['family_name']}`

                if(window.location.pathname == '/'){
                    this._router.navigate(['/dashboard', 'home']);
                }
            }
        });
    }
}
